import React from "react";
import { Helmet } from "react-helmet-async";

const Jamtara = () => {
  return (
    <>
      <Helmet>
        <title>Fly Ash Bricks, Blocks & Paver Blocks in Jamtara | Anil Flyash Bricks</title>
        <meta
          name="description"
          content="Buy durable and eco-friendly fly ash bricks, blocks, and paver blocks in Jamtara from Anil Flyash Bricks — trusted manufacturer and dealer serving Jamtara, Mihijam, and nearby Jharkhand areas."
        />
        <meta
          name="keywords"
          content="bricks in Jamtara, flyash bricks in Jamtara, fly ash blocks in Jamtara, bricks dealers in Jamtara, flyash bricks manufacturer Jamtara, paver block Jamtara, construction bricks Jamtara, Anil Flyash Bricks Jamtara"
        />
        <link rel="canonical" href="https://anilbricks.com/flyash-bricks-in-jamtara" />
      </Helmet>

      <div className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-green-700 text-center">
          Fly Ash Bricks, Blocks & Paver Blocks in Jamtara
        </h1>

        <p className="text-lg leading-relaxed mb-4">
          <strong>Anil Flyash Bricks</strong> proudly serves <strong>Jamtara</strong> and nearby
          areas such as <strong>Mihijam, Nala, and Kundhit</strong> with premium-quality
          <strong> fly ash bricks, fly ash blocks, and paver blocks</strong>. Our goal is to
          provide sustainable, high-strength, and affordable construction materials that meet
          modern building standards.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Our <strong>fly ash bricks</strong> are made using advanced manufacturing techniques
          that ensure excellent compressive strength, uniform shape, and long-lasting durability.
          These bricks are a perfect alternative to traditional clay bricks — reducing environmental
          impact while delivering superior performance.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          We also offer <strong>fly ash blocks</strong> and <strong>paver blocks</strong> that are
          ideal for residential, commercial, and industrial projects. Our paver blocks are
          available in multiple colors, designs, and thicknesses — perfect for footpaths,
          parking areas, driveways, and outdoor landscapes in Jamtara.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Whether you're searching for <em>“bricks dealers in Jamtara”</em>,
          <em>“paver block manufacturer near me”</em>, or
          <em>“fly ash block supplier in Jharkhand”</em>,
          <strong>Anil Flyash Bricks</strong> is the brand you can rely on for consistent quality,
          timely delivery, and competitive pricing.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          We serve customers across Jamtara district and surrounding regions with a strong focus
          on reliability and customer satisfaction. For bulk orders, dealership, or franchise
          opportunities, contact <strong>Anil Flyash Bricks</strong> today and experience premium
          products at affordable rates.
        </p>

        <a
          href="/"
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold shadow-md transition"
        >
          Visit Main Website
        </a>
      </div>
    </>
  );
};

export default Jamtara;
